import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { logout, selectAccountSession, StoreService } from '@shared/store';
import { TokenUtil } from '@shared/utils/token.util';

export const accountRouteGuard: CanActivateFn = () => {
  const store = inject(StoreService);
  const router = inject(Router);
  const session = store.select(selectAccountSession());
  if (session && TokenUtil.tokenIsValid(session.identityToken)) {
    return true;
  }
  else if (session) {
    store.dispatch(logout());
  }
  return router.parseUrl('/login?error=loginTimeout');
};
